import { Link } from "react-router-dom";
import { ArrowUpRight, Eye, Moon, Newspaper, Terminal } from "lucide-react";

const themes = [
  {
    key: "midnight",
    name: "Midnight Tech",
    blurb: "Dark slate with electric blue/cyan accents. Cabinet Grotesk + Satoshi. Modern, premium, globally appealing — current direction.",
    icon: Moon,
    palette: ["#050505", "#0A0C13", "#2563EB", "#67E8F9"],
    href: "/preview/midnight",
  },
  {
    key: "editorial",
    name: "Editorial Premium",
    blurb: "Warm cream + deep navy + Playfair Display serif headlines. Boardroom-grade authority — think senior consulting and McKinsey.",
    icon: Newspaper,
    palette: ["#FAF7F2", "#FFFFFF", "#0B1F3A", "#8B6F2E"],
    href: "/preview/editorial",
  },
  {
    key: "cyber",
    name: "Cyber SecOps",
    blurb: "Pure black + acid green / amber + JetBrains Mono. Terminal aesthetic that mirrors your SOC/SIEM and AI Security focus.",
    icon: Terminal,
    palette: ["#000000", "#0A0A0A", "#00FF7F", "#FFB627"],
    href: "/preview/cyber",
  },
];

export default function ThemesIndex() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="themes-index">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500 mb-3">
          Theme picker · aksahni.com
        </div>
        <h1 className="font-display font-bold text-4xl md:text-6xl tracking-tighter text-white leading-[0.95]">
          Pick a direction. <br />
          <span className="text-slate-500">Same site, three personalities.</span>
        </h1>
        <p className="mt-6 text-slate-400 text-lg max-w-2xl leading-relaxed">
          Each preview is a complete landing experience in a different aesthetic.
          Open them in tabs, compare, and tell me which one feels like you.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {themes.map((t) => (
            <Link
              key={t.key}
              to={t.href}
              data-testid={`theme-card-${t.key}`}
              className="group bg-[#0A0C13] border border-white/10 rounded-2xl p-7 hover:border-white/30 hover:-translate-y-1 transition-all"
            >
              <div className="flex items-center justify-between">
                <div className="h-10 w-10 rounded-lg bg-white/5 border border-white/10 grid place-items-center text-blue-300">
                  <t.icon size={18} />
                </div>
                <ArrowUpRight size={16} className="text-slate-500 group-hover:text-white transition-colors" />
              </div>
              <div className="mt-5 font-display font-bold text-2xl text-white tracking-tight">
                {t.name}
              </div>
              <p className="mt-2 text-slate-400 text-sm leading-relaxed">{t.blurb}</p>
              <div className="mt-5 flex items-center gap-2">
                {t.palette.map((c) => (
                  <span
                    key={c}
                    className="h-7 w-7 rounded-full border border-white/20"
                    style={{ background: c }}
                  />
                ))}
              </div>
              <div className="mt-6 inline-flex items-center gap-2 text-sm text-blue-300 group-hover:text-blue-200">
                <Eye size={14} /> Open preview
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-16 text-xs text-slate-500 max-w-2xl">
          Once you pick a winner, I'll apply it site-wide, switch the brand to
          aksahni.com everywhere, and walk you through deploying to the live
          domain.
        </div>
      </div>
    </div>
  );
}
